import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/sti-reverse-scan/scan-empty-state.svg'
import _imports_1 from '@/app/ui/assets/svg/noData_filter.svg'
import _imports_2 from '@/app/ui/assets/svg/no-data-list.svg'
import _imports_3 from '@/app/ui/assets/svg/image-modal-success.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-79fb814a")

_pushScopeId("data-v-79fb814a")
const _hoisted_1 = { class: "flex flex-col gap-4 w-full items-center h-full" }
const _hoisted_2 = {
  class: "relative w-full",
  style: { minHeight: 'auto' }
}
const _hoisted_3 = { class: "absolute top-1 left-0" }
const _hoisted_4 = { class: "absolute top-1 right-0" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-3 justify-center items-center w-full"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "empty-state"
}, null, -1)
const _hoisted_7 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col justify-center items-center gap-2 w-full"
}
const _hoisted_9 = { class: "input-scan w-full" }
const _hoisted_10 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_11 = { class: "flex flex-row gap-2.5 items-center justify-start" }
const _hoisted_12 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_13 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_14 = { class: "flex flex-row rounded-lg gap-x-4" }
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_17 = { class: "ml-4 text-14px font-semibold text-black-lp-100" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1px","background":"#D4D5D8"},
  class: "h-auto"
}, null, -1)
const _hoisted_19 = { class: "flex flex-row" }
const _hoisted_20 = { class: "text-14px font-normal text-gray-lp-800" }
const _hoisted_21 = { class: "ml-4 text-14px font-semibold text-black-lp-100" }
const _hoisted_22 = { class: "w-full h-full" }
const _hoisted_23 = {
  key: 1,
  class: "flex justify-center w-full h-full flex-col items-center"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "not-data-filter",
  width: "160",
  height: "135"
}, null, -1)
const _hoisted_25 = { class: "text-sm text-gray-lp-800" }
const _hoisted_26 = {
  key: 1,
  src: _imports_2,
  alt: "not-data-list",
  width: "160",
  height: "135"
}
const _hoisted_27 = { class: "text-sm text-gray-lp-800" }
const _hoisted_28 = {
  class: "flex flex-col justify-center items-center gap-2",
  style: {"max-width":"353px"}
}
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  width: "124",
  alt: ""
}, null, -1)
const _hoisted_30 = { class: "text-center text-sm text-gray-lp-300 font-semibold" }
const _hoisted_31 = { class: "text-center text-xs text-gray-lp-800" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_ScanFailedCard = _resolveComponent("ScanFailedCard")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_STIReverseScanIllustration = _resolveComponent("STIReverseScanIllustration")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Search = _resolveComponent("Search")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    title: _ctx.$t('sti.updateButton'),
    onBack: () => _ctx.$router.push({ name: 'STI' }),
    "vertical-separator": false,
    "full-page": ""
  }, {
    data: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_Transition, { name: "summary-card" }, {
              default: _withId(() => [
                (_ctx.STISTTDueSummaryData.posName && _ctx.currentTotalSummary)
                  ? (_openBlock(), _createBlock(_component_SummaryCard, {
                      key: 0,
                      posName: _ctx.STISTTDueSummaryData.posName,
                      current: _ctx.currentTotalSummary,
                      total: _ctx.STISTTDueSummaryData.total,
                      stOverdue: _ctx.STISTTDueSummaryData.stOverdue,
                      onAction: _ctx.goToNeedToStiPage
                    }, null, 8, ["posName", "current", "total", "stOverdue", "onAction"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_Transition, { name: "notification" }, {
              default: _withId(() => [
                (_ctx.STIScanFailedList.length)
                  ? (_openBlock(), _createBlock(_component_ScanFailedCard, {
                      key: 0,
                      data: _ctx.STIScanFailedList
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (_ctx.illustrationData.isEmpty && !_ctx.loadingIllustration)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("sti.updateSti.scanPromptEmpty")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.controller.isLoadingTemporaryList || _ctx.loadingIllustration)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_Skeleton, {
                  width: "283px",
                  height: "61px"
                }),
                _createVNode(_component_Skeleton, {
                  width: "264px",
                  height: "110px"
                }),
                _createVNode(_component_Skeleton, {
                  width: "205px",
                  height: "24px"
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loadingIllustration && !_ctx.illustrationData.isEmpty)
            ? (_openBlock(), _createBlock(_component_STIReverseScanIllustration, {
                key: 2,
                class: "w-full flex justify-center",
                flag: _ctx.illustrationData.flag,
                "region-name": _ctx.illustrationData.regionName,
                "is-STT": _ctx.illustrationData.isSTT,
                "is-sti-dest": _ctx.illustrationData.isStiDest,
                "is-invalid": _ctx.illustrationData.isInvalid,
                "is-underpaid": _ctx.illustrationData.isUnderpaid,
                "is-dangerous-goods": _ctx.illustrationData.isDangerousGoods,
                "is-woodpacking": _ctx.illustrationData.isWoodpacking,
                "is-relabel": _ctx.illustrationData.isRelabel,
                "is-duplicate-scan": _ctx.isDuplicateScan
              }, null, 8, ["flag", "region-name", "is-STT", "is-sti-dest", "is-invalid", "is-underpaid", "is-dangerous-goods", "is-woodpacking", "is-relabel", "is-duplicate-scan"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_lp_input, {
            ref: "inputStt",
            modelValue: _ctx.form.sttNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.sttNumber = $event)),
            sizeInput: "24px",
            bold: !!_ctx.form.sttNumber,
            labelStacked: _ctx.$t('Contoh : 99LP1234567890123/88-22-12345678'),
            placeholder: _ctx.$t('Masukan No. STT atau Scan Barcode/QR Code'),
            onEnter: _ctx.onScanSttNumber,
            onFocus: _ctx.onSetFocusRefs
          }, null, 8, ["modelValue", "bold", "labelStacked", "placeholder", "onEnter", "onFocus"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Search, {
              class: "w-full mr-0",
              style: {"margin-right":"0","width":"220px"},
              placeholder: _ctx.$t('sti.updateSti.searchPlaceholderBagStt'),
              value: _ctx.form.search,
              onInput: _ctx.onSearch,
              onClear: _ctx.onClearSearch
            }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
            _createVNode(_component_SelectSearch, {
              placeholder: _ctx.$t('sti.updateSti.allPartner'),
              customWidth: "w-52",
              serverSide: false,
              options: _ctx.controller.bookedListOptions,
              modelValue: _ctx.form.booked,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.booked = $event)),
              onChange: _ctx.fetchTemporaryList
            }, null, 8, ["placeholder", "options", "modelValue", "onChange"])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_lp_button, {
              title: _ctx.$t('processSti.stiDestination'),
              textColor: _ctx.filterButtonStyle.textColor,
              customClass: _ctx.filterButtonStyle.customClass,
              color: _ctx.filterButtonStyle.color,
              onClick: _cache[3] || (_cache[3] = 
                () => {
                  _ctx.form.stiDestFilter = !_ctx.form.stiDestFilter;
                  _ctx.fetchTemporaryList();
                }
              )
            }, null, 8, ["title", "textColor", "customClass", "color"]),
            _createVNode(_component_CustomDropdown, {
              style: {"width":"168px"},
              selectedItem: _ctx.form.statusReturn,
              options: _ctx.filterOptions,
              placeholder: _ctx.$t('sti.updateSti.packageMarker'),
              onSelect: _ctx.onFilter
            }, null, 8, ["selectedItem", "options", "placeholder", "onSelect"]),
            _createVNode(_component_lp_button, {
              onClick: _ctx.onConfirmStiManifest,
              title: _ctx.$t('sti.updateSti.processManifest'),
              "text-color": "white",
              disabled: 
                !_ctx.temporaryList.length ||
                  _ctx.loadingIllustration ||
                  _ctx.controller.isLoadingTemporaryList ||
                  _ctx.loadingSummarySti
              
            }, null, 8, ["onClick", "title", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("sti.updateSti.totalSttKoli")), 1),
              _createVNode("p", _hoisted_17, _toDisplayString(_ctx.totalStt) + "/" + _toDisplayString(_ctx.totalPieces), 1)
            ]),
            _hoisted_18,
            _createVNode("div", _hoisted_19, [
              _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("sti.updateSti.grossWeight")), 1),
              _createVNode("p", _hoisted_21, _toDisplayString(_ctx.formatWeight(_ctx.totalGrossWeight)), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          (_ctx.temporaryList.length || _ctx.controller.isLoadingTemporaryList)
            ? (_openBlock(), _createBlock(_component_TableV2, {
                key: 0,
                columns: _ctx.columns,
                data: _ctx.temporaryList,
                "pagination-style": "v2",
                "is-hard-pagination": true,
                pagination: _ctx.pagination,
                isPinnedScrollBottom: "",
                pinnedSubstractHeight: "260px",
                loading: _ctx.controller.isLoadingTemporaryList
              }, null, 8, ["columns", "data", "pagination", "loading"]))
            : _createCommentVNode("", true),
          (!_ctx.temporaryList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                (_ctx.form.search || _ctx.form.booked.value || _ctx.form.statusReturn.value)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_24,
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("sti.updateSti.notFoundFilter")), 1)
                    ], 64))
                  : (_openBlock(), _createBlock("img", _hoisted_26)),
                _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("sti.updateSti.noPackageScanned")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isConfirmManifestModal)
        ? (_openBlock(), _createBlock(_component_ModalV2, {
            key: 0,
            showBorderTitle: false,
            showFooter: false,
            width: "w-104 sti-reverse-scan-modal",
            onClose: 
          () => {
            _ctx.isConfirmManifestModal = false;
          }
        
          }, {
            content: _withId(() => [
              _createVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("sti.updateSti.modalConfirmMessage")), 1),
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("sti.updateSti.modalConfirmSubtext")), 1),
                _createVNode(_component_LpButton, {
                  class: "w-full",
                  customClass: "w-full",
                  textColor: "white",
                  fontBold: "",
                  title: _ctx.$t('sti.updateSti.modalConfirmButton'),
                  onClick: _ctx.stiProcessReverseManifest,
                  onEnter: _ctx.stiProcessReverseManifest
                }, null, 8, ["title", "onClick", "onEnter"])
              ])
            ]),
            _: 1
          }, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onBack"]))
})